import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 39 39"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19.747 11H0V0h19.747c4.596 0 9.302 2.223 12.786 5.43C36.089 8.705 39 13.593 39 19.5s-2.911 10.795-6.467 14.07C29.049 36.777 24.343 39 19.747 39H0V28h19.747c1.328 0 3.533-.777 5.48-2.57 1.874-1.725 2.912-3.837 2.912-5.93s-1.038-4.205-2.912-5.93C23.28 11.777 21.075 11 19.747 11",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }